/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const OrderListRequestDTOOrderStatusesEnum = {
    PendingAvailability: 'PENDING_AVAILABILITY',
    Pending: 'PENDING',
    Unshipped: 'UNSHIPPED',
    PartiallyShipped: 'PARTIALLY_SHIPPED',
    Shipped: 'SHIPPED',
    InvoiceUnconfirmed: 'INVOICE_UNCONFIRMED',
    Cancelled: 'CANCELLED',
    Unfulfillable: 'UNFULFILLABLE'
};
/**
 * @export
 */
export const OrderListRequestDTOPackageStatusesEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * Check if a given object implements the OrderListRequestDTO interface.
 */
export function instanceOfOrderListRequestDTO(value) {
    return true;
}
export function OrderListRequestDTOFromJSON(json) {
    return OrderListRequestDTOFromJSONTyped(json, false);
}
export function OrderListRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'search': json['search'] == null ? undefined : json['search'],
        'sellingPriceMin': json['sellingPriceMin'] == null ? undefined : json['sellingPriceMin'],
        'sellingPriceMax': json['sellingPriceMax'] == null ? undefined : json['sellingPriceMax'],
        'purchaseDateFrom': json['purchaseDateFrom'] == null ? undefined : (new Date(json['purchaseDateFrom'])),
        'purchaseDateTo': json['purchaseDateTo'] == null ? undefined : (new Date(json['purchaseDateTo'])),
        'shipByDateFrom': json['shipByDateFrom'] == null ? undefined : (new Date(json['shipByDateFrom'])),
        'shipByDateTo': json['shipByDateTo'] == null ? undefined : (new Date(json['shipByDateTo'])),
        'deliverByDateFrom': json['deliverByDateFrom'] == null ? undefined : (new Date(json['deliverByDateFrom'])),
        'deliverByDateTo': json['deliverByDateTo'] == null ? undefined : (new Date(json['deliverByDateTo'])),
        'orderStatuses': json['orderStatuses'] == null ? undefined : json['orderStatuses'],
        'packageStatuses': json['packageStatuses'] == null ? undefined : json['packageStatuses'],
        'rootCategories': json['rootCategories'] == null ? undefined : json['rootCategories'],
        'flagIds': json['flagIds'] == null ? undefined : json['flagIds'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}
export function OrderListRequestDTOToJSON(json) {
    return OrderListRequestDTOToJSONTyped(json, false);
}
export function OrderListRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'search': value['search'],
        'sellingPriceMin': value['sellingPriceMin'],
        'sellingPriceMax': value['sellingPriceMax'],
        'purchaseDateFrom': value['purchaseDateFrom'] == null ? undefined : ((value['purchaseDateFrom']).toISOString()),
        'purchaseDateTo': value['purchaseDateTo'] == null ? undefined : ((value['purchaseDateTo']).toISOString()),
        'shipByDateFrom': value['shipByDateFrom'] == null ? undefined : ((value['shipByDateFrom']).toISOString()),
        'shipByDateTo': value['shipByDateTo'] == null ? undefined : ((value['shipByDateTo']).toISOString()),
        'deliverByDateFrom': value['deliverByDateFrom'] == null ? undefined : ((value['deliverByDateFrom']).toISOString()),
        'deliverByDateTo': value['deliverByDateTo'] == null ? undefined : ((value['deliverByDateTo']).toISOString()),
        'orderStatuses': value['orderStatuses'],
        'packageStatuses': value['packageStatuses'],
        'rootCategories': value['rootCategories'],
        'flagIds': value['flagIds'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}
